export default "__VITE_ASSET__BcXTEIJp__"